module.exports = __webpack_public_path__ + "static/img/kscj.8d2d528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kscj.png
// module id = gdZm
// module chunks = 9